'use strict';

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('../../utils'),
    sortBy = _require.sortBy;

var Entry = require('./entry');

var Wantlist = /*#__PURE__*/function () {
  function Wantlist(stats) {
    _classCallCheck(this, Wantlist);

    this.set = new Map();
    this._stats = stats;
  }

  _createClass(Wantlist, [{
    key: "add",
    value: function add(cid, priority) {
      var cidStr = cid.toString('base58btc');
      var entry = this.set.get(cidStr);

      if (entry) {
        entry.inc();
        entry.priority = priority;
      } else {
        this.set.set(cidStr, new Entry(cid, priority));

        if (this._stats) {
          this._stats.push(null, 'wantListSize', 1);
        }
      }
    }
  }, {
    key: "remove",
    value: function remove(cid) {
      var cidStr = cid.toString('base58btc');
      var entry = this.set.get(cidStr);

      if (!entry) {
        return;
      }

      entry.dec(); // only delete when no refs are held

      if (entry.hasRefs()) {
        return;
      }

      this.set.delete(cidStr);

      if (this._stats) {
        this._stats.push(null, 'wantListSize', -1);
      }
    }
  }, {
    key: "removeForce",
    value: function removeForce(cidStr) {
      if (this.set.has(cidStr)) {
        this.set.delete(cidStr);
      }
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      return this.set.forEach(fn);
    }
  }, {
    key: "entries",
    value: function entries() {
      return this.set.entries();
    }
  }, {
    key: "sortedEntries",
    value: function sortedEntries() {
      return new Map(sortBy(function (o) {
        return o[1].key;
      }, Array.from(this.set.entries())));
    }
  }, {
    key: "contains",
    value: function contains(cid) {
      var cidStr = cid.toString('base58btc');
      return this.set.get(cidStr);
    }
  }, {
    key: "length",
    get: function get() {
      return this.set.size;
    }
  }]);

  return Wantlist;
}();

Wantlist.Entry = Entry;
module.exports = Wantlist;